/**
 * Resolves local relative paths (like `/uploads/...`) by prepending the backend host
 * from the environment configuration (VITE_API_BASE_URL) if available.
 */
export function resolveImageUrl(url: string | null | undefined): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }

  const apiBase = import.meta.env.VITE_API_BASE_URL || '';
  if (apiBase.startsWith('http://') || apiBase.startsWith('https://')) {
    try {
      const parsed = new URL(apiBase);
      const cleanUrl = url.startsWith('/') ? url : `/${url}`;
      return `${parsed.origin}${cleanUrl}`;
    } catch {
      // fallback
    }
  }

  return url;
}

/**
 * Builds the URL for an uploaded logo / employee photo stored in the backend logos
 * directory. The filename is passed as a ?f= query parameter so the request PATH
 * carries no image extension — this prevents extension-based nginx `location` rules
 * (e.g. `~* \.(png|jpg)$`) from intercepting the request and returning 404 instead of
 * proxying it to the backend. Returns '' for empty/missing names.
 */
export function logoUrl(name: string | null | undefined): string {
  if (!name) return '';
  // Already a full URL or data URI — leave untouched.
  if (name.startsWith('http://') || name.startsWith('https://') || name.startsWith('data:') || name.startsWith('/api/public/img')) {
    return name;
  }
  return `/api/public/img?f=${encodeURIComponent(name)}`;
}
